import data from '../../partners/partner_names.json';

const { partners, activeYSC, activeLSC, activeCP, yscNames, lscNames, cpNames, partnerNameCorrections } = data;

const access = ['*', 'fiscal', 'dashboard', 'upload', ...partners];

const sortByValue = (obj) => Object.fromEntries(Object.entries(obj).sort(([, a], [, b]) => a.localeCompare(b)));

const CBOS = {
  ysc: {
    AllYSC: 'All YSC',
    ...sortByValue(yscNames),
  },
  lsc: {
    AllLSC: 'All LSC',
    ...sortByValue(lscNames),
  },
  cp: {
    AllCP: 'All CP',
    ...sortByValue(cpNames),
  },
  allsc: {
    AllSC: 'All agencies',
    ...sortByValue({ ...yscNames, ...lscNames, ...cpNames }),
  },
};

const getActivePartners = () => [...activeYSC, ...activeLSC, ...activeCP];

const correctPartnerName = (fileName) => {
  const lowerFileName = fileName.toLowerCase();
  const active = partners.find((partner) => lowerFileName.includes(partner.toLowerCase()));
  if (active) {
    return active.toLowerCase();
  }

  for (const [correctName, variations] of Object.entries(partnerNameCorrections)) {
    if (variations.some((variation) => lowerFileName.includes(variation))) {
      return correctName.toLowerCase();
    }
  }

  return fileName.toLowerCase();
};

const partnerMetadata = { partners, access, CBOS, getActivePartners, correctPartnerName };

export default partnerMetadata;
export { partners, access, CBOS, getActivePartners, correctPartnerName };
